export default __webpack_public_path__ + "static/media/logo.095ca175.png";